module.exports = __webpack_public_path__ + "img/1.4e87cb79.png";